import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link as RouterLink } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import news from "../../content/news.json";
import NewsCard from "../News/NewsCard";

const News = () => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        px: { xs: 2, sm: 4 },
        py: { xs: 6, md: 9 },
        bgcolor: "white",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 1180, mx: "auto" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Box>
            <Typography
              variant="overline"
              color={theme.palette.primary.main}
              sx={{ fontWeight: 900 }}
            >
              Latest stories
            </Typography>
            <Typography
              variant="h2"
              color={theme.palette.primary.main}
              sx={{ fontSize: { xs: "2rem", md: "3rem" }, lineHeight: 1.05 }}
            >
              News
            </Typography>
          </Box>
          <Button
            endIcon={<ArrowForwardIcon />}
            component={RouterLink}
            to="/news"
            sx={{ display: { xs: "none", sm: "inline-flex" }, alignSelf: "end" }}
          >
            View all news
          </Button>
        </Box>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: 720,
            color: "text.secondary",
            fontSize: { xs: "1rem", md: "1.08rem" },
            lineHeight: 1.7,
          }}
        >
          Stories from Lacor Hospital and the patients, families and clinicians
          connected through the Cyrenaeus partnership.
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(3, minmax(0, 1fr))",
            },
            alignItems: "stretch",
            pt: 3,
            gap: 2.5,
          }}
        >
          {news.slice(0, 3).map((article, index) => (
            <NewsCard key={`${article.title}-${index}`} {...article} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default News;
